import * as React from 'react';

/**
 * Feature flag testing page
 */
export default function FlaggedPage() {
    return <h1>You can only see this if the feature flag is on</h1>;
}
